/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Feature category enum matching database type
 */
export enum FeatureCategory {

    Momentum = 'Momentum',

    Microstructure = 'Microstructure',

    Volume = 'Volume',

    Technical = 'Technical',

    Orderbook = 'Orderbook',

    Temporal = 'Temporal',

    Custom = 'Custom'
}
